import ValueRange from '../../../models/ValueRange.js';
import template from './ko-field-view-number-range.html';

class NumberRangeComponentVM
{
	constructor(params)
	{
		this.params = params;
		this.value = ko_helper.safe_observable(params.value);
		this.extra_classes = ko_helper.safe_observableArray(params.extra_classes || []);

		this.value_range = new ValueRange(this.value, {
			serialize_function: (val) =>
			{
				if (!val) return '';
				return parseFloat(val).toString();
			},
			deserialize_function: (val) =>
			{
				if (!val) return '';
				return parseFloat(val);
			}
		});
	}
}


export default {
	name: 'ko-field-view-number-range',
	viewModel: NumberRangeComponentVM,
	module_type: 'ko',
	template: template
};
